import { z } from 'zod';

export const DeduplicationRoleSchema = z.enum([
  'primary_operation',
  'supporting_evidence',
]);

export type DeduplicationRole = z.infer<typeof DeduplicationRoleSchema>;
